import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ResponsiveDialog from 'ui/components/ResponsiveDialog';
import { usePluginActivationRedirect } from '../../../hooks/use-activate-plugin';
import {
  getShowForgotPassword,
  getShowLogin,
  getShowRegister,
  setShowForgotPassword,
  setShowLogin, setShowRegister,
  setSignupOption,
} from '../../../store/userSlice';
import { ForgotPasswordModal } from './forgot-password-modal';
import { LoginModal } from './login-modal';
import { RegisterModal } from './register-modal';

export const LoginRegisterModal = () => {
  const dispatch = useDispatch()
  const forgotPassword = useSelector(getShowForgotPassword)
  const login = useSelector(getShowLogin)
  const register = useSelector(getShowRegister)

  const { handleCloseActivationLogin } = usePluginActivationRedirect()

  const handleOpenChange = (open: boolean) => {
    const activationCallback = new URL(window.location.toString()).searchParams.get('activation_callback');
    if (!open) {
      if (activationCallback) {
        dispatch(setShowForgotPassword(false))
        dispatch(setShowLogin(false))
        dispatch(setShowRegister(false))
        handleCloseActivationLogin()
        dispatch(setSignupOption(''));
      }
      dispatch(setShowForgotPassword(false))
      dispatch(setShowLogin(false))
      dispatch(setShowRegister(false))
      dispatch(setSignupOption(''));
    }
  }
  const collab = new URL(window.location.toString()).searchParams.get(
    'collab'
  )

  const marketingSiteSite = new URL(window.location.toString()).searchParams.get(
    'new'
  )

  useEffect(() => {
    if (collab || marketingSiteSite) {
      dispatch(setShowRegister(true))
      dispatch(setShowLogin(false))
    }
  }, [collab, marketingSiteSite, dispatch])

  return <ResponsiveDialog open={true} onOpenChange={handleOpenChange}>
    {forgotPassword && <ForgotPasswordModal />}
    {login && <LoginModal />}
    {register && <RegisterModal />}
  </ResponsiveDialog>
}